"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _AppDataField = require("../AppDataField");

var _actions = require("../actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _ReportDetailImageFieldTemplate = require("../../../containers/reportDetail/ReportDetailImageFieldTemplate");

var _ReportDetailImageFieldTemplate2 = _interopRequireDefault(_ReportDetailImageFieldTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageAppDataField = function ImageAppDataField(dataField, contentDataField) {
    var _this = this;

    var isWithinTable = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

    _classCallCheck(this, ImageAppDataField);

    this.key = function () {
        return _this.dataField.uid;
    };
    this.setValue = function (value) {
        value = value || null;
        if (!_.isArray(value)) {
            _.set(_this, "contentDataField.data.attachmentUids", value);
        } else {
            _.set(_this, "contentDataField.data.attachmentUids", _.head(value));
        }
    };
    this.currentFormValue = function () {
        var currentFormValue = (0, _selectn2.default)("data.attachmentUids", _this.contentDataField);
        return currentFormValue;
    };
    this.appSchemaObject = function () {
        var schema = {};
        _.set(schema, _this.key(), _this.dataField.isMandatory ? t.String : t.maybe(t.String));
        return schema;
    };
    this.appSchemaStruct = function () {
        return t.struct(_this.appSchemaObject(), _this.dataField.uid);
    };
    this.appSchemaFieldOptions = function (formattedMessage) {
        var disabled = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

        var field = {};
        _.set(field, _this.key(), {
            label: _this.isWithinTable ? null : _this.dataField.title,
            help: (0, _AppDataField.helpContainer)(true, _this.dataField.description),
            template: _this.template,
            disabled: disabled
        });
        return field;
    };
    this.pictureAvailableChanged = function () {
        return;
    };
    // overwrite current value with new value
    this.addItem = function (attachmentUid, dispatch) {
        _this.setValue(attachmentUid);
        dispatch(reportDetailActions.updateReportWithAppDataField(_this));
    };
    this.removeItem = function (attachmentUid, dispatch) {
        _this.setValue(null);
        dispatch(reportDetailActions.updateReportWithAppDataField(_this));
    };
    this.template = function (locals) {
        var titleText = _this.dataField.title;
        if (_this.dataField.isMandatory === false) {
            titleText += " (Optional)";
        }
        return React.createElement("div", { style: { width: _AppDataField.containerWidth } }, React.createElement(_ReportDetailImageFieldTemplate2.default, { locals: locals, fieldUid: _this.dataField.uid, title: titleText, addItem: _this.addItem, removeItem: _this.removeItem }));
    };
    this.copy = function () {
        return new ImageAppDataField(_this.dataField, _this.contentDataField);
    };
    this.contentDataField = contentDataField;
    this.dataField = dataField;
    this.isWithinTable = isWithinTable;
    this.contentDataField = Object.assign({}, contentDataField, {
        type: "attachment",
        uid: dataField.uid
    });
    this.setValue(this.currentFormValue());
};

exports.default = ImageAppDataField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/fields/ImageAppDataField.tsx
 ** module id = 637
 ** module chunks = 0
 **/